import { readPacket, writePacket } from '../core/packets'

export class SocketLocal {
  constructor(server, params) {
    this.server = server
    this.params = params
    this.receiver = null
  }

  setReceiver(receiver) {
    this.receiver = receiver
  }

  connect() {
    this.connection = this.server.connect(this.params, this._onPacket, this._onClose)
  }

  send(name, data) {
    const packet = writePacket(name, data)
    this.connection.send(packet)
  }

  _onPacket = packet => {
    const msg = readPacket(packet)
    this.receiver.onPacket(msg)
  }

  _onClose = e => {
    this.connection = null
    const code = e?.code || null
    const reason = e?.reason || null
    this.receiver.onClose(code, reason)
  }
}
